Layout.store.state = {
    menuExpanded: false,
};